module.exports = __webpack_public_path__ + "img/939c0a2.jpg";